import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Typography, Button } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import * as sessionActions from '../../redux/actions/sessionActions';
import { clearTenantArrivals } from '../../utils/tenantAccessGuard';

// Shown instead of the legacy iframe when the signed in account has no access to the
// tenant (see utils/tenantAccessGuard.js). Loading the iframe would only bring up the sugar
// login page, which sends the whole app back here - the reload loop this replaces.
export class TenantAccessDenied extends React.Component {
    switchTenant = (tenantId) => {
        window.location.href = "/yerp?tenant=" + tenantId;
    }

    loginWithAnotherAccount = () => {
        clearTenantArrivals();
        sessionStorage.removeItem("tenant_id");
        localStorage.removeItem("tenant_id");
        this.props.actions.logout();
    }

    render() {
        const { t, user, tenantId } = this.props;
        const profile = !!user ? user.profile : null;
        const account = !!profile ? (profile.preferred_username || profile.email || profile.name || '') : '';
        const otherTenants = (this.props.availableTenants || []).filter(tenant => tenant.id !== tenantId);

        return (
            <div id="tenant-access-denied" style={{ display: 'flex', justifyContent: 'center', padding: '40px 16px' }}>
                <Paper style={{ maxWidth: 560, width: '100%', padding: 24 }}>
                    <Typography variant="h6" gutterBottom>{t("NoAccessToTenant")}</Typography>
                    <Typography variant="body1" gutterBottom>
                        {t(otherTenants.length > 0 ? "NoAccessToTenantHelp" : "NoAccessToTenantHelpNoTenants", { account })}
                    </Typography>
                    {otherTenants.length > 0 && (
                        <div style={{ marginTop: 16 }}>
                            <Typography variant="subtitle2">{t("SwitchTenant")}</Typography>
                            {otherTenants.map(tenant => (
                                <Button
                                    key={tenant.id}
                                    variant="outlined"
                                    color="primary"
                                    style={{ margin: '8px 8px 0 0' }}
                                    onClick={() => this.switchTenant(tenant.id)}
                                >{tenant.name}</Button>
                            ))}
                        </div>
                    )}
                    <Button
                        id="tenant-access-denied-logout"
                        className="upButtonWithText"
                        variant="contained"
                        color="primary"
                        style={{ marginTop: 24 }}
                        onClick={this.loginWithAnotherAccount}
                    >{t("LoginWithAnotherAccount")}</Button>
                </Paper>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        availableTenants: state.availableTenants
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            logout: bindActionCreators(sessionActions.logout, dispatch)
        }
    };
}

export default compose(withTranslation('common'),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(TenantAccessDenied);
